<template>
    <div>
        <div v-if="!isRunningNets && !isRunningSwish && !isPaymentComplete" :class="{'tw:space-y-4': wizardStore.tw}">

            <h5 v-if="wizardStore.bookingTerms || wizardStore.productTerms.length" :class="{'tw:block tw:text-sm tw:font-medium tw:text-zinc-800': wizardStore.tw}">{{ $t('Bestillingsvilkår') }}</h5>
            <div :class="{'card mb-1': !wizardStore.tw}" v-if="wizardStore.bookingTerms">
                <div
                    :class="{'card-body p-2 terms-body': !wizardStore.tw, 'tw:p-4 tw:bg-white tw:border tw:border-zinc-200 tw:rounded-lg terms-body tw:text-base': wizardStore.tw}">
                    <p><small v-html="wizardStore.bookingTerms"></small></p>

                    <p v-if="wizardStore.hasFullBookingTerms">
                        <small>
                            <a class="text-underline" :href="wizardStore.termsPageUrl" target="_blank">
                                {{ $t("Les fullstendige vilkår") }} <i class="fa fa-link"></i>
                            </a>
                        </small>
                    </p>
                    <input type="hidden" name="terms_approved" value="0">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="terms_approved" value="1"
                                   v-model="wizardStore.hasApprovedBookingTerms"> {{ $t("Påkrevd") }} -
                            {{ $t("Jeg godkjenner vilkårene vist ovenfor") }}
                        </label>
                    </div>
                </div>
            </div>
            <div :class="{'card mb-1': !wizardStore.tw}" v-for="(term, i) in wizardStore.productTerms" :key="i">
                <div :class="{'card-body p-2 terms-body': !wizardStore.tw, 'tw:p-4 tw:bg-white tw:border tw:border-zinc-200 tw:rounded-lg terms-body tw:text-base': wizardStore.tw}">
                    <small v-if="term.file_url">
                        <a :href="term.file_url" target="_blank"
                           style="text-decoration-line: underline">{{ term.file_name }} <span
                            class="fa fa-external-link"></span></a>
                    </small>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" value="1" v-model="term.approved" class="me-1">
                            <span v-if="term.required">
                                {{ $t("Påkrevd") }} {{ term.text ? ' - ' : '' }}
                            </span>

                            <span class="product-terms-text" v-html="term.text"></span>
                        </label>
                    </div>
                </div>
            </div>

            <h5 :class="{'my-2': !wizardStore.tw, 'tw:mt-2 tw:block tw:text-sm tw:font-medium tw:text-zinc-800': wizardStore.tw}">{{ $t('Velg betalingsalternativ') }}</h5>
            <div class="col-lg-12 mt-2" id="trigger-swish-button" v-if="hasSwish && !isLoadingPayment">
                <div
                    :class="{'card shadow-hover shadow-sm cursor-pointer': !wizardStore.tw, 'tw:transition tw:hover:scale-102 tw:shadow-xs tw:hover:shadow tw:border tw:border-zinc-200 tw:rounded-xl tw:cursor-pointer tw:mb-2': wizardStore.tw}"
                    @click="triggerSwish()">
                    <div :class="{'card-body': !wizardStore.tw, 'tw:py-4 tw:px-6': wizardStore.tw}">
                        <div :style="{'min-height: 50px;': !wizardStore.tw}" :class="{'row': !wizardStore.tw, 'tw:min-h-[50px] tw:flex tw:justify-between tw:items-center': wizardStore.tw}">
                            <div :class="{'col-8 d-flex': !wizardStore.tw}">
                                <h5 :class="{'mb-0 fw-bold align-self-center': !wizardStore.tw, 'tw:font-semibold tw:m-0': wizardStore.tw}">{{ $t('Hurtigbetaling med Swish') }}</h5>
                            </div>
                            <div :class="{'col-4': !wizardStore.tw}">
                                <img
                                    src="https://cdn.stroptima.se/tabselev/img/swish/swish-logo-primary-light-bg-2025.svg"
                                    alt="Swish logo" class="img-fluid d-block align-self-center w-auto"
                                    style="height: 50px; margin: 0 auto;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mt-2" v-if="hasNets && !isLoadingPayment">
                <div
                    :class="{'card shadow-hover shadow-sm cursor-pointer': !wizardStore.tw, 'tw:transition tw:shadow-sm tw:hover:scale-102 tw:hover:shadow tw:border tw:border-zinc-200 tw:rounded-xl tw:cursor-pointer tw:mb-2': wizardStore.tw}"
                     @click="triggerNets()">
                    <div :class="{'card-body': !wizardStore.tw, 'tw:py-4 tw:px-6': wizardStore.tw}">
                        <div :style="{'min-height: 50px;': !wizardStore.tw}" :class="{'row': !wizardStore.tw, 'tw:min-h-[50px] tw:flex tw:justify-between tw:items-center': wizardStore.tw}">
                            <div class="col-8 d-flex">
                                <h5 :class="{'mb-0 fw-bold align-self-center': !wizardStore.tw, 'tw:font-semibold tw:m-0': wizardStore.tw}">{{ $t('Betal med kort') }}</h5>
                            </div>
                            <div class="col-4 d-flex">
                                <img src="https://cdn.stroptima.se/tabselev/img/nets-easy.png" alt="Visa logo"
                                     class="img-fluid d-block align-self-center w-auto"
                                     style="max-height: 50px; margin: 0 auto;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 mt-4" v-if="!hasSwish && !hasNets">
                <div class="alert alert-danger">
                    {{ $t('Kan ikke fullføre bestillingen. Trafikkskolen mangler betalingsalternativer.') }}
                </div>
            </div>
        </div>
        <loadingSpinner :isLoading="isLoadingPayment" :tw="wizardStore.tw"></loadingSpinner>
        <div v-if="paymentError" class="alert alert-danger mt-2">
            {{ paymentError }}
        </div>

        <div v-if="isRunningNets">
            <div id="checkout-container-div"></div>
            <div class="text-center">
                <div :class="{'btn btn-danger rounded-0 mt-2': !wizardStore.tw, 'tw:text-xs tw:ml-4 tw:bg-(--shop-primary) tw:inline-block tw:rounded-0 tw:px-2 tw:py-1 tw:cursor-pointer tw:rounded-4xl tw:text-white': wizardStore.tw}" @click="clearReservedBooking('cancelled')">
                    <i class="fa fa-times"></i> {{ $t("Avbryt") }}
                </div>
            </div>
        </div>

        <div v-if="isRunningSwish" id="swish-payment-container">
            <img v-if="swishQrCode" alt="Swish QR-code" style="display: block; margin: 0 auto 20px;" id="swish-qr-code"
                 class="swish-qr-code" :src="swishQrCode"/>
            <div class="text-center tw:text-center">
                <a href="#" v-if="swishPaymentDeeplink" class="swish-deeplink"
                   :class="{'btn btn-primary btn-block mb-2': !wizardStore.tw, 'tw:no-underline tw:inline-block tw:mx-auto tw:px-4 tw:py-2 tw:bg-(--shop-primary) tw:text-white tw:rounded-4xl tw:cursor-pointer tw:mb-2': wizardStore.tw}"
                   @click="navigateToSwishApp">{{ $t("Gå videre til Swish appen") }}</a>
                <p :class="{'text-center': !wizardStore.tw, 'tw:block tw:text-sm tw:font-medium tw:text-zinc-800 tw:text-center': wizardStore.tw }" v-if="swishPaymentMessage">{{ swishPaymentMessage }}</p>
            </div>

            <div class="alert hide" id="swish-payment-result"></div>
            <p :class="{'alert alert-info text-center': !wizardStore.tw, 'tw:rounded-md tw:text-base tw:border tw:border-blue-200 tw:bg-blue-50 tw:p-4 tw:text-slate-600': wizardStore.tw}" v-if="wizardStore.hasFullBookingTerms">
                <small>{{ $t("Ved å gjennomføre denne betalingen godtar du våre bestillingsvilkår") }}:
                    <br>
                    <a class="text-underline" href="/booking-terms" target="_blank">
                        {{ $t("Les fullstendige vilkår") }} <i class="fa fa-link"></i>
                    </a>
                </small>
            </p>
            <div class="text-center" v-if="displayClearReservedBookingButton">
                <div :class="{'btn btn-danger rounded-0 mt-2': !wizardStore.tw, 'tw:text-xs tw:ml-4 tw:bg-(--shop-primary) tw:inline-block tw:rounded-0 tw:px-2 tw:py-1 tw:cursor-pointer tw:rounded-4xl tw:text-white': wizardStore.tw}" @click="clearReservedBooking('cancelled')">
                    <i class="fa fa-times"></i> {{ $t("Avbryt") }}
                </div>
            </div>
        </div>

        <div v-if="isPaymentComplete">
            <h3>{{ $t("Takk for din bestilling!") }}</h3>

            <p>
                {{
                    $t("Som kund på {officeName} får du tillgång till Elevcentralen. Där kan du följa din utbildning, se ditt konto, boka körlektioner och kommunicera med din trafikutbildare.", {officeName: officeName})
                }}
                <br>
                {{ $t('Klicka här för att kommer till ') }} <a :href="studentPageUrl">{{ studentPageName }}</a>
            </p>
            <p>
                {{ $t('Du vil motta bekreftelse på epost og på ') }}<a :href="studentPageUrl">{{ studentPageName }}</a>.
            </p>
        </div>
    </div>
</template>

<script setup>
    import {useWizardStore} from "./wizardState.js";
    import LoadingSpinner from "./loadingSpinner.vue";
    import {ref} from 'vue';

    const wizardStore = useWizardStore();

    const props = defineProps({
        hasSwish: {
            type: Boolean,
            default: false
        },
        hasNets: {
            type: Boolean,
            default: false
        },
        officeName: {
            type: String,
            default: ''
        },
        brandingDomain: {
            type: String,
            default: ''
        },
        studentPageName: {
            type: String,
            default: ''
        }
    });
    const studentPageUrl = ref(`https://${props.brandingDomain}`);


    const isRunningNets = ref(false);
    const transactionRef = ref(null);
    const isRunningSwish = ref(false);
    const isPaymentComplete = ref(false);

    const isLoadingPayment = ref(false);
    const paymentError = ref(null);

    const reservationTimeout = ref(null);
    const statusAttempts = ref(0);
    const secondsBetweenEachCheck = ref(3);
    const swishQrCode = ref(null);
    const swishPaymentMessage = ref(null);
    const swishPaymentDeeplink = ref(null);
    const displayClearReservedBookingButton = ref(true);

    function resetPaymentInfo() {
        isRunningNets.value = false;
        isRunningSwish.value = false;
        transactionRef.value = null;
        paymentError.value = null;
        swishQrCode.value = null;
        swishPaymentMessage.value = null;
        swishPaymentDeeplink.value = null;
    }

    function startReservationTimeout() {
        clearReservationTimeout();
        reservationTimeout.value = window.setTimeout(() => {
            isRunningNets.value = false;
            isRunningSwish.value = false;

            transactionRef.value = null;
            isLoadingPayment.value = false;

            paymentError.value = TABS.$t('Betalingen tok for lang tid. Vennligst prøv igjen.');
            clearReservedBooking('timeout')
        }, TABS.optima.getReservationTimeoutLimitInSeconds()); // 60 seconds timeout

        TABS.optima.modalCloseHandler = function () {
            clearReservedBooking('js-close');
        };

        document.querySelectorAll(".modal.show, .tabs-modal").forEach(el => {
            el.addEventListener("hidden.bs.modal", TABS.optima.modalCloseHandler);
        });
    }

    function clearReservationTimeout() {
        if (reservationTimeout.value) {
            window.clearTimeout(reservationTimeout.value);
            reservationTimeout.value = null;
        }
        document.querySelectorAll(".modal.show, .tabs-modal").forEach(el => {
            el.removeEventListener("hidden.bs.modal", TABS.optima.modalCloseHandler);
        });
    }

    function clearReservedBooking(reason) {
        TABS.booking.request('clear-reserved', null, function (res) {
            // Res isn't used.
        }, {
            ref: transactionRef.value,
            user_id: wizardStore.student.userId,
            reason: reason,
        });
        clearReservationTimeout();
        resetPaymentInfo();
    }

    function hasConfirmedTerms() {
        if (wizardStore.bookingTerms && !wizardStore.hasApprovedBookingTerms) {
            paymentError.value = TABS.$t('Du må godkjenne bestillingsvilkårene for å fortsette.');
            return false;
        }
        if (wizardStore.productTerms.length > 0) {
            const allTermsApproved = wizardStore.productTerms.every(term => term.approved || !term.required);
            if (!allTermsApproved) {
                paymentError.value = TABS.$t('Du må godkjenne alle påkrevde vilkår for å fortsette.');
                return false;
            }
        }
        return true;
    }

    function scrollPaymentIntoView(elementId) {
        setTimeout(() => {
            const el = document.getElementById(elementId);
            if (el) {
                el.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }, 50)
    }

    function triggerSwish() {
        if (!hasConfirmedTerms()) {
            return;
        }
        if (isLoadingPayment.value) {
            return;
        }
        resetPaymentInfo();

        isLoadingPayment.value = true;
        const data = getPaymentData();

        try {
            TABS.booking.request('optima-trigger-swish', null, function (res) {
                startReservationTimeout();
                isLoadingPayment.value = false;
                if (res.success) {
                    isRunningSwish.value = true;
                    scrollPaymentIntoView('swish-payment-container');
                    transactionRef.value = res.data.transaction;
                    if (res.data.redirect) {
                        // redirect to swish
                        checkSwishPayment();
                        window.onbeforeunload = null;
                        swishPaymentDeeplink.value = res.data.message;
                        return;
                    }
                    if (res.data.qr_code) {
                        swishQrCode.value = 'data:image/png;base64,' + res.data.qr_code;
                    }
                    if (res.data.message) {
                        swishPaymentMessage.value = res.data.message
                    }
                    checkSwishPayment();
                } else {
                    clearReservationTimeout();
                    paymentError.value = res.error;
                }
            }, data);
        } catch (e) {
            isLoadingPayment.value = false;
            paymentError.value = TABS.$t('Noe gikk galt under betaling. Vennligst prøv igjen.');
            console.error('Error triggering Swish payment:', e);
        }
    }

    function checkSwishPayment() {
        if (!isRunningSwish.value) {
            return;
        }
        TABS.booking.request('p-status', null, function (res) {
            statusAttempts.value++;
            console.log('swish res', res)
            if (!document.querySelector('.tabs-modal.show') && !document.getElementById('p-fallback-status') && !document.getElementById('swish-payment-result')) {
                console.log('Swish modal closed, stopping status checks');
                // Modal closed. Don't fetch status anymore
                return;
            }
            if (res.inprogress) {
                setTimeout(function () {
                    checkSwishPayment();
                }, secondsBetweenEachCheck.value * 1000);
            } else {
                clearReservationTimeout();
                showPaymentResult(res);
            }
        }, {ref: transactionRef.value}, 3);
    }

    function showPaymentResult(res) {
        resetPaymentInfo();

        if (res.data.status === 'approved') {
            isPaymentComplete.value = true;
        } else {
            paymentError.value = res.data.message;
        }
    }

    function navigateToSwishApp() {
        if (window.self === window.top) {
            window.location = swishPaymentDeeplink.value;
        } else {
            window.triggerSwishFailedTimeout = window.setTimeout(function () {
                resetPaymentInfo()
                clearReservationTimeout()
                paymentError.value = TABS.$t('Kunne ikke åpne Swish. Prøv et annet betalingsalternativ.');
            }, 1000);
            window.top.postMessage({
                eventName: 'swish:payment',
                swishPaymentDeeplink: swishPaymentDeeplink.value,
            }, '*');
            paymentError.value = TABS.$t('Videresender deg nå til Swish appen.');
        }
    }

    function triggerNets() {
        if (!hasConfirmedTerms()) {
            return;
        }
        if (isLoadingPayment.value) {
            return;
        }
        resetPaymentInfo();
        isLoadingPayment.value = true;
        const data = getPaymentData();

        window.TABS.booking.request('optima-trigger-nets', null, function (res) {
            startReservationTimeout();
            isLoadingPayment.value = false;
            if (res.success) {
                if (res.data.transaction) {
                    isRunningNets.value = true;
                    scrollPaymentIntoView('checkout-container-div');
                    setTimeout(() => {
                        transactionRef.value = res.data.transaction;
                        const checkoutOptions = {
                            checkoutKey: res.data.netsEasyCheckoutKey,
                            paymentId: res.data.paymentId,
                            containerId: "checkout-container-div",
                            language: "sv-SE",
                        };
                        const checkout = new Dibs.Checkout(checkoutOptions);

                        checkout.on('payment-completed', function (response) {
                            clearReservationTimeout();

                            TABS.optima.paymentInProgress(response['paymentId'], transactionRef.value);
                            isPaymentComplete.value = true;
                            displayClearReservedBookingButton.value = false;
                        });
                    }, 50)
                }
            } else {
                clearReservationTimeout();
                paymentError.value = res.error;
            }
        }, data);
    }

    function getPaymentData() {
        return {
            user_id: wizardStore.student.userId,
            class_id: wizardStore.classId,
            course_id: wizardStore.courseId,
            teacher_id: wizardStore.teacherId,
            product_id: wizardStore.productId,
            package_id: wizardStore.packageId,
            start: wizardStore.start,
            end: wizardStore.end,
            add_student_ids: wizardStore.getStudentIds(),
            product_terms: wizardStore.productTerms,
            current_url: window.location.href,
            with_interpreters: wizardStore.getInterpreterIds(),
            delivery_option: wizardStore.selectedDeliveryOption,
            resource_class_ids: wizardStore.getResourcePoolClassIds,
            comment: wizardStore.student.comment,
        };
    }
</script>
